import { render, staticRenderFns } from "./payQrcode.vue?vue&type=template&id=67fac706&scoped=true"
import script from "./payQrcode.vue?vue&type=script&lang=js"
export * from "./payQrcode.vue?vue&type=script&lang=js"
import style0 from "./payQrcode.vue?vue&type=style&index=0&id=67fac706&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67fac706",
  null
  
)

export default component.exports